<template>
  <div>
    <div>
      新竹物流包裹才積若超過10才(長*寬*高/27000=才數）因為會佔用較多的車廂空間或者物品超過50kg人力不易搬運需要使用棧板，符合其中任意一種情形，新竹可能酌情加收費用統稱為棧板費。
      <br>
      <br>
      棧板費依地區有不同的收費標準，如下：
    </div>
    <table class="table-comment mt-1">
      <tr>
        <td width="80">
          北北基
        </td>
        <td>1000 元</td>
      </tr>
      <tr>
        <td>桃竹苗</td>
        <td>1200 元</td>
      </tr>
      <tr>
        <td>中彰投</td>
        <td>1500 元</td>
      </tr>
      <tr>
        <td>雲嘉南</td>
        <td>1800 元</td>
      </tr>
      <tr>
        <td>高高屏</td>
        <td>2000 元</td>
      </tr>
      <tr>
        <td>宜花東</td>
        <td>2200 元</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    transport: String,
    addrid: String,
    isPersonal: Boolean,
  }
}
</script>
